import { useState } from "react";
import Searchbar from "./Searchbar";
import Dropdown from "./Dropdown";
import CountriesList from "./CountriesList";
import useTheme from "../hooks/UseTheme";

export default function Home() {
  const [query, setQuery] = useState("");
  console.log(query);
  // const [IsDark] = useOutletContext()
  // const [IsDark] = useContext(ThemeContext)
  const [IsDark] = useTheme();

  return (
    <main className={`${IsDark ? "dark" : ""}`}>
      <div className="search-filter-container">
        <Searchbar setQuery={setQuery} />
        <Dropdown setQuery={setQuery} />
      </div>
      <CountriesList query={query} />
    </main>
  );
}
